import request from '@/utils/request'
export const getFormApi = (data) => {
    return request({
        url: 'SystemParameter/byData',
        method: 'post',
        data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'SystemParameter/save',
        method: 'post',
        data
    })
}